import React, { Component } from "react";
import { RequestHeaders } from "../../common/header-logo/request-header.component";
import ButtonIcon from '../../button';
import Icons from '../../icon';
import "./manage-component.css";
//import { PaginationExhibit1 as Pagination } from "../../common/table/pagination.component";
import { TabberButton } from "../../common/custom-form/tabber-button.component";
import { AddQuestionModal } from "./modal/manage-csat/add-question-modal.container";
import { DeleteQuestionModal } from "./modal/manage-csat/delete-question-confirmation.container";
export class ManageCSAT extends Component {
    constructor(props) {
        super(props);
       this.state={
           toggle:false
       }
    }

    componentDidMount() {
        this.toggleFunction()
    }

    toggleFunction() {
       this.setState({toggle:!this.state.toggle})
    }

    render() {
        const commentLst=["Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book. It usually begins with:", "sample Comment", "sample Comment"]
        const pages = {
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
        return(
            <div>
                <RequestHeaders headerTitle="Manage CSAT Survey" />   
                <div className="request-table data-table internal-data-table csat-container">
                    <div>
                        <div className="add-comment-btn-container">
                            <AddQuestionModal />
                        </div>
                    </div>
                   
                    <div>
                        <table className="table-fit table">
                                <thead>
                                    <tr>
                                    <th>Questions</th>
                                    <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>                               
                                    {commentLst.map((item,id)=>
                                            <tr key={id}>
                                                <td className="item-list">{item}</td>       
                                                <td className="item-list item-icon">
                                                <TabberButton label="Active"/>
                                                <DeleteQuestionModal />
                                                </td>  
                                            </tr>                           
                                    )}                               
                                </tbody>                            
                        </table>
                        {/* <Pagination pages={pages} /> */}
                    </div>
                </div>
            </div>
        )
    }
}